## 从当前卡点开始查攻略

《控制: 共振》（CONTROL Resonant）里最常见的困惑往往很具体：隐藏墙没有打开、能力二选一拿不定主意，或任务装置已经放好却没有推进。本站把答案放在攻略前面，后面再解释位置、操作顺序和排查方法。所有文字攻略无需账号，关闭 JavaScript 也能阅读。技能和任务同时保留英文名，方便与游戏菜单或其他资料对照。

## 技能怎么选，先看你的战斗习惯

[配装规划器](/build-planner)支持五个分组各选一项。先想清楚自己习惯贴身攻击、拉开距离、依赖武器还是优先防御，再组合能力。工具的玩法标签用来概括搭配方向，不计算伤害、DPS 或强度评分，也不会读取你的存档。Command 只展示固定解锁说明。需要选择第一组能力时，可以先看 [Barrage、Volatile Anomaly 与 Shield 对比](/abilities/barrage-vs-volatile-anomaly-vs-shield)；关注站位则看 [Ground Slam 与 Push](/abilities/ground-slam-vs-push)，火焰搭配则看 [Ignite 与 Inferno](/abilities/ignite-vs-inferno)。

## 秘密藏身处密码与解谜顺序

先确认店名和区域，再照攻略操作。市中心和公园都有 Atlantis 餐厅，但前者需要按顺序操作物件，后者使用收银机密码。想快速查找入口，可以打开[谜题攻略汇总](/puzzles)。[Urban Fresh 密码 1213](/puzzles/urban-fresh-code)与[公园 Atlantis 密码 BDAC](/puzzles/atlantis-code-the-park)属于直接输入型谜题；[洗衣店开关图](/puzzles/wear-em-wash-em-laundromat)、[健身房五步顺序](/puzzles/pulse-fitness)和[美术馆灯柱位置](/puzzles/art-gallery-evacuation-zone)则要核对机器状态、速度标签和观察方向。原创示意图用于辅助定位，不替代游戏内的具体标识。

## 任务卡关时逐项核对条件

装置放置成功，不一定等于已经启动；供电、清除敌人和完成前置校准也可能是不同条件。[Power Lines 任务攻略](/quests/power-lines)按车站改道与平台 A、B 校准整理步骤；[Into the Sinkhole 攻略](/quests/into-the-sinkhole)则覆盖探针中继装置、逃离平台与音乐提示。先比对日志当前目标，再检查场景变化，不要仅凭装置的外观判断任务是否完成。

## Build Power 与成就不是一回事

[Build Power（配装整体强度）说明](/guides/build-power)解释游戏内成长指标；网站保存的配装不会提升该数值。[第六个技能槽解锁攻略](/trophies/combat-readiness-sixth-ability-slot)另列通关后的任务要求。[卡拉 OK 九次选择答案](/trophies/karaoke-answers)仅记录方向，不复制歌词。开始可能影响奖杯的流程前，先检查存档是否足以回退，并留意页面的核验日期和资料来源。

## 本地保存与分享链接

浏览器允许存储时，配装会保存在本机；分享链接中的五个有效参数优先于旧存档。清除只移除当前分组，重置会清空选择和保存状态。中文页面生成的分享链接保留中文路径，切换语言也会保留所选技能。存储被禁用时仍可操作；复制失败时会显示可以手动复制的链接。链接仅包含能力选择，不包含游戏存档或账号信息。

## 资料与反馈

本站是独立玩家工具站，和 Remedy 没有隶属关系。攻略标注来源，配装建议属于玩法分析，不冒充实测结论。若发现某个步骤与当前版本不同，请先核对区域和游戏版本，再将页面地址与问题描述发送至 [support@controlresonanttools.online](mailto:support@controlresonanttools.online)。[关于本站](/about)介绍资料核验与纠错方式。
